import { render, staticRenderFns } from "./ViewDiscountSlabs.vue?vue&type=template&id=0480c5dc&"
import script from "./ViewDiscountSlabs.vue?vue&type=script&lang=js&"
export * from "./ViewDiscountSlabs.vue?vue&type=script&lang=js&"
import style0 from "./ViewDiscountSlabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports